import { useState } from 'react'

import ArrowRightIcon from '@heroicons/react/outline/ArrowRightIcon'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'

import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

import { CollectionFormModal } from '../../../Collection/CollectionFormModal'
import { CreateSpaceModal } from '../../../Space/CreateSpaceModal'
import { SupportModal } from '../../../SupportModal'
import { UserImportModal } from '../../../UserImport'
import { sections } from './sections'

export const GettingStarted = () => {
  const [activeSection, setActiveSection] = useState('engagement')
  const [activeModal, setActiveModal] = useState(null)
  const section = sections?.find(section => section.key === activeSection)
  const { push } = useHistory()
  return (
    <div className="max-w-5xl m-auto">
      <h3 className="mb-3">Getting started</h3>
      <Card className="grid grid-cols-12 gap-2">
        <Card.Content className="col-span-12 lg:col-span-4">
          <NavVertical>
            <NavVertical.Group className="space-y-5">
              {sections.map(section => (
                <NavVertical.Item
                  key={section.title}
                  active={activeSection === section.key}
                  as={Link}
                  onClick={() => {
                    if (section.modal) {
                      setActiveModal(section.modal)
                    } else {
                      setActiveSection(section.key)
                    }
                  }}
                  leadingIcon={section.icon}
                >
                  <span>{section.title}</span>
                </NavVertical.Item>
              ))}
            </NavVertical.Group>
          </NavVertical>
        </Card.Content>
        <Card.Content className="col-span-12 lg:col-span-8">
          <h3 className="mb-3">{section?.title}</h3>
          <Tabs.Group>
            {section?.tabs?.length > 1 ? (
              <Tabs.List variant="pills">
                {section.tabs.map(tab => (
                  <Tabs.Tab key={tab.title}>{tab.title}</Tabs.Tab>
                ))}
              </Tabs.List>
            ) : null}
            <Tabs.Panels>
              {section?.tabs?.map(tab => (
                <Tabs.Panel key={tab.title}>
                  <div className="flex flex-col space-y-8">
                    <div className="flex flex-col space-y-5 py-5">
                      {tab?.content}
                    </div>
                    {tab?.actions ? (
                      <div className="flex flex-col space-y-2">
                        {tab?.actions?.map(action => (
                          <div key={action.title}>
                            <Button
                              size="lg"
                              variant="outline"
                              trailingIcon={<ArrowRightIcon />}
                              onClick={() => {
                                if (action.modal) setActiveModal(action.modal)
                                else if (action.link) {
                                  push(action.link)
                                } else if (action.href) {
                                  document.location = action.href
                                }
                              }}
                            >
                              {action.title}
                            </Button>
                          </div>
                        ))}
                      </div>
                    ) : null}
                    {tab?.tips?.length ? (
                      <Alert title="Tips!" status="info">
                        <List spacing="sm">
                          {tab?.tips?.map(tip => (
                            <List.Item key={tip}>{tip}</List.Item>
                          ))}
                        </List>
                      </Alert>
                    ) : null}
                  </div>
                </Tabs.Panel>
              ))}
            </Tabs.Panels>
          </Tabs.Group>
        </Card.Content>
      </Card>
      {activeModal === 'space' && (
        <CreateSpaceModal open onClose={() => setActiveModal(null)} />
      )}
      {activeModal === 'collection' && (
        <CollectionFormModal open onClose={() => setActiveModal(null)} />
      )}
      {activeModal === 'invitation' && (
        <UserImportModal open onClose={() => setActiveModal(null)} />
      )}
      {activeModal === 'support' && (
        <SupportModal open onClose={() => setActiveModal(null)} />
      )}
    </div>
  )
}
